function getMedalistsFromSpreadSheet() {
	return fetch("https://sheets.googleapis.com/v4/spreadsheets/1AvcCnUAyhXjGxfUovPOTCXbcGjoslZgq2sl9oF0FaiM/values/Sheet1?key=AIzaSyDCdrJESjdmYJETV-JhV_ZXOOfxsqMHCtM")
  			.then(response => response.json())
  			.then(response => {
  	var medalists = {"Medalists":[]};
	const entries = response.values;
	var id = -1;
	
	for (const entry of entries) {
		++id;
		if (entry.length == 0) {
			continue;
		}

		var medalist = {
			"id": id,
			"first": entry[0],
			"last": entry[1],
			"year": entry[2],
			"bio": entry[3],
			"profile_photo_file_name": entry[4],
			"is_society_member": entry[5],
			"prefix": entry[6],
		};

		medalists["Medalists"].push({...medalist});
	}

	return medalists;
})
  			.catch((error) => {
    			// handle your errors here
    			console.error(error)
  	});
}

module.exports = { getMedalistsFromSpreadSheet };



// WEBPACK FOOTER //
// ./src/Medalists.js